import axios from "axios";
import config from "./config";
const API_BASE = process.env.REACT_APP_BACKEND_API + "/api/merchant";

export const createMerchant = async (payload) => {
  try {
    const response = await axios.post(
      `${API_BASE}/CreateMerchant`,
      payload,
      config()
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    if (error.response) {
      return { status: error.response.status, data: error.response.data };
    }
    return { status: 500, data: null };
  }
};
